var _style, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXtz(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2C7DF7;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 150,
    cy: 150,
    r: 150
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M174.5,264.4c-16.3,0-28.3-3.9-35.8-11.8c-7-6.7-11-15.8-11.2-25.4c-0.1-2.9,0.6-5.8,2-8.4 c1.3-2.2,3.1-4.1,5.4-5.4c5.3-2.6,11.4-2.6,16.7,0c2.2,1.3,4.1,3.1,5.3,5.4c1.4,2.6,2.1,5.5,2,8.4c0.1,3.5-0.9,7-2.9,9.8 c-1.7,2.3-4.1,4.1-6.8,5c2.7,3.4,6.5,5.8,10.7,6.7c4.8,1.4,9.7,2.1,14.6,2.1c6.6,0.1,13-1.9,18.4-5.5c5.6-4,9.9-9.7,12-16.3 c2.7-7.8,4.1-16.1,3.9-24.4c0.2-8.6-1.2-17.2-4.3-25.3c-2.3-6.5-6.7-12-12.4-15.7c-5.3-3.4-11.6-5.2-17.9-5.1 c-5.5,0.5-10.8,2.3-15.5,5.3l-11.5,5.8v-5.8l51.6-69.2h-71.5v71.8c-0.2,5.2,1.2,10.3,3.9,14.7c2.7,3.9,7.3,6.1,12,5.8 c4.3-0.1,8.5-1.6,11.9-4.2c3.9-2.8,7.2-6.3,9.9-10.2c0.2-0.7,0.7-1.3,1.3-1.7c0.5-0.4,1.1-0.6,1.7-0.6c1.2,0.1,2.4,0.6,3.4,1.4 c1.2,1.3,1.8,3.1,1.8,4.9c-0.1,1.2-0.4,2.4-0.6,3.6c-2.5,6.1-6.8,11.4-12.3,15.2c-5.1,3.4-11.1,5.3-17.2,5.2 c-15.5,0-26.2-3.1-32.2-9.2c-6.2-6.8-9.4-15.8-8.9-25V94.5H66V81.2h36.5V50.8l-8.4-8.4v-6.8h24.3l9.1,4.7v40.9l94.5-0.3l9.4,9.4 l-57.9,58.2c3.5-1.4,7.2-2.3,10.9-2.6c7.4,0.3,14.7,2.4,21.2,6c7.5,3.6,13.8,9.2,18.2,16.3c3.9,6,6.7,12.6,8.2,19.6 c1.2,5.5,1.9,11.2,2,16.8c0,10.8-2.4,21.5-7.2,31.1c-4.5,9.4-12.1,17-21.5,21.5C195.8,262,185.2,264.5,174.5,264.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtz);
export default __webpack_public_path__ + "static/media/XTZ.d3d4bdf5d3a1395c1ed30ed14034d6f8.svg";
export { ForwardRef as ReactComponent };